angular.module('elidb').filter('feature', function() {
    return function(listing,start,end) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = [];

    	for(var i = 0, count = listing.length; i < count; i++)
    	{
    		var tag = listing[i];
            if(!tag.rank) continue;
    		results.push(tag);
    	}

        results.sort(function(a,b){
            if(a.rank < b.rank) return 1;
            if(a.rank > b.rank) return -1;
            return 0;
        });
    	return results;
    };
});